/* eslint max-params: ["error", 4] */
import { IPageAddCallback, api, ICategoryAddCallback } from "./index";
import { message, Modal } from "antd";
import { lang } from "../context";
// import events from '../context/events';
// import SyncJoySpaceController from '../controllers/SyncJoySpaceController';
// import { SyncStatusEunm } from '../controllers/JoyspaceController';
import { FileType } from "../types";
import {
  getOptions,
  securitySetModal,
  SelectValEnum,
  SecuresTypeValEnum,
  SelectRoleEnum
} from "@jd/focus-joyspace-comps";
import { addSecuritySettings, getSecuritySettings } from "../api/permissions";

const { confirm } = Modal;

const categorySecurity: ICategoryAddCallback = (props, isAllow, isZhuanban?: boolean) => {
  const { data } = props;
  const info = data;
  const fileType: any = FileType.Folder;
  let result: any = [];
  let getRoleIdBySelectVal = (roleId: number) => {
    if (fileType === FileType.Folder) {
      switch (roleId) {
        case SelectRoleEnum.FolderAll:
          return SelectValEnum.ALL;
        case SelectRoleEnum.FolderOnlyEdit:
          return SelectValEnum.EDIT_OWNER;
        case SelectRoleEnum.FolderOnlyOwner:
          return SelectValEnum.OWNER;
        default:
      }
    } else if (fileType === FileType.Page) {
      switch (roleId) {
        case SelectRoleEnum.FileAll:
          return SelectValEnum.ALL;
        case SelectRoleEnum.FileOnlyEdit:
          return SelectValEnum.EDIT_OWNER;
        case SelectRoleEnum.FileOnlyOwner:
          return SelectValEnum.OWNER;
        default:
      }
    }
  };
  const onOK = async (list: any, setData: any, selectItem: any) => {
    // result = await getSecuritySettings(info.id, fileType);
    // console.log(info.id, fileType, list, "info.id, fileType, list====>");
    addSecuritySettings(info.id, fileType, list).then(async (res: any) => {
      // console.log(res, "addSecuritySettings======>");
      // if (res && typeof res !== "boolean") {
      //   return;
      // }
      result = await getSecuritySettings(info.id, fileType);
      let show =
        result.find((item: any) => item.securesType === selectItem.securesType)?.show ||
        SelectValEnum.ALL;
      let options = getOptions(fileType, show, selectItem.securesType);
      console.log(options, "optionsoptionsoptionsoptions", result);
      setData(options);
    });
  };
  const createDataFormat = (preData = [], selectItem: any) => {
    let newData = preData.map((item: any) => {
      item.secureType = item.securesType;
      if (item.securesType === selectItem.securesType) {
        item.roleId = selectItem.roleId;
        item.secureType = selectItem.securesType;
      }
      delete item.bizId;
      delete item.bizType;
      delete item.securesType;
      delete item.show;
      return item;
    });
    return newData;
  };
  return [
    {
      children: lang("common.security-ettings"),
      callbackOrModal: async () => {
        result = await getSecuritySettings(info.id, fileType);
        console.log(result, "resultresultresultresultresult");
        let shareItem = result.find((item: any) => item.securesType === SecuresTypeValEnum.Share);
        let downlaodItem = result.find(
          (item: any) => item.securesType === SecuresTypeValEnum.Download
        );

        securitySetModal({
          title: "文件夹安全设置",
          type: fileType,
          shareShowValue: shareItem.show,
          downloadShowValue: downlaodItem.show,
          defaultShareValue: getRoleIdBySelectVal(Number(shareItem.roleId)) ?? SelectValEnum.ALL,
          defaultDownloadValue:
            getRoleIdBySelectVal(Number(downlaodItem.roleId)) ?? SelectValEnum.ALL,
          callback: (item: any, setData: any) => {
            console.log(result, item, "item=======>");
            const newData = createDataFormat(result, item);
            onOK(newData, setData, item);
          }
        });
      },
      isAllow,
      type: "securitySet",
      icon: "ic_pc_safesetting_doc",
      splitCode: 1
      // splitCode: 2,
      // tip: '如需设置该选项，请先联系文件夹所有者修改安全设置。',
    }
  ];
};

export default categorySecurity;
